import { render, staticRenderFns } from "./ExteriorCarWheelCarousel.vue?vue&type=template&id=db10f5e6&scoped=true&"
import script from "./ExteriorCarWheelCarousel.vue?vue&type=script&lang=js&"
export * from "./ExteriorCarWheelCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db10f5e6",
  null
  
)

export default component.exports